import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.map";
import getClassicLink from './get-classic-link';
import getIconName from './get-icon-name';
import NavigationItemRecord from '../../../../../records/NavigationItemRecord';
import NavigationMenuTileRecord from '../../../../../records/NavigationMenuTileRecord';
export default function mapSubSectionLinks(links) {
  return links.map(function (subSectionLink) {
    var linkItem = getClassicLink(subSectionLink);
    return new NavigationMenuTileRecord({
      iconName: getIconName(subSectionLink),
      link: new NavigationItemRecord(linkItem),
      body: subSectionLink.description
    });
  });
}